export default{snack:"w_HI",message:"w_HJ"};
